import { isCollectionBlock } from '@/lib/blocks/collection/blocks';
import { isParentBlockType, type PageBlock } from '@/types/block';
import type { IndicatorEdge } from './core';

export const isCollectionScopedDrag = ({
  activeParent,
  targetParent,
}: {
  activeParent: PageBlock | undefined;
  targetParent: PageBlock | undefined;
}): boolean => {
  return Boolean(
    (activeParent && isCollectionBlock(activeParent)) ||
      (targetParent && isCollectionBlock(targetParent)),
  );
};

export const hasExplicitSideGroupingIntent = ({
  isGapZoneTarget,
  indicatorEdge,
}: {
  isGapZoneTarget: boolean;
  indicatorEdge: IndicatorEdge | null;
}): boolean => {
  return Boolean(isGapZoneTarget && (indicatorEdge === 'left' || indicatorEdge === 'right'));
};

export const isConstrainedParentExitAttempt = ({
  activeParent,
  activeParentId,
  targetParentId,
}: {
  activeParent: PageBlock | undefined;
  activeParentId: string | null;
  targetParentId: string | null;
}): boolean => {
  const leavingCollection =
    Boolean(activeParent && isCollectionBlock(activeParent)) && targetParentId !== activeParentId;
  return leavingCollection;
};

export const canTargetParentAcceptActiveBlock = ({
  targetParent,
}: {
  activeBlock: PageBlock;
  targetParent: PageBlock | undefined;
}): boolean => {
  if (!targetParent || !isParentBlockType(targetParent.blockType)) {
    return false;
  }

  if (isCollectionBlock(targetParent)) {
    return false;
  }

  return true;
};
